import { Component } from '@angular/core';
import { tabsData, columnDefs } from './ops-vendors-list.config';
import { Router } from '@angular/router';
import { OpsVendorListEnum, VendorListEnum } from '@constants/global.enum';
import { paginationParams } from 'src/app/shared/config/table.config';
import { VendorDropdownOptions } from 'src/app/shared/constants/constants';
import { truncateText } from '@utils/utils';
import { OpsVendosListService } from './ops-vendos-list.service';
import { OpsVendorList, OpsVendorListResponse } from '@app/shared/interfaces/ops-vendor-list';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ops-vendors-list',
  templateUrl: './ops-vendors-list.component.html',
  styleUrls: ['./ops-vendors-list.component.scss'],
})
export class OpsVendorsListComponent {
  tabsData = tabsData;
  columnDefs = columnDefs;
  onboarderedRowData: OpsVendorList[] = [];
  updateRequestRowData: any[] = [];
  paginationParams = {
    ...paginationParams,
    totalItems: 0,
    pageIndex: 0,
  };
  selectedTab = this.tabsData[0];
  VendorListEnum = VendorListEnum;
  OpsVendorListEnum = OpsVendorListEnum;
  showDropdown = false;
  dropdownRowIndex: number | null = null;
  dropdownPosition: any = {};

  constructor(
    private router: Router,
    private opsVendorsListService: OpsVendosListService,
    private toaster: ToastrService,
  ) {}

  ngOnInit() {
    this.selectedTab = this.tabsData[0];
    if (this.selectedTab?.key?.includes(VendorListEnum.onBoardered)) {
      this.getOnboarded();
    } else {
      this.getUpdateRequests();
    }
  }

  getOnboarded() {
    this.opsVendorsListService.getOnboarded().subscribe({
      next: ({ data }: OpsVendorListResponse) => {
        this.onboarderedRowData = data;
        this.updatePaginationParams();
        this.getTabLabel();
      },
      error: (error) => {
        this.toaster.error(this.OpsVendorListEnum.Error);
      },
    });
  }

  getUpdateRequests() {
    this.updateRequestRowData = [];
  }

  getTabLabel() {
    const setTabLabel = (key: string, labelPrefix: string, count: number) => {
      const tab = this.tabsData.find((tab) => tab.key === key);
      if (tab) tab.label = `${labelPrefix} (${count})`;
    };

    setTabLabel(
      VendorListEnum.onBoardered,
      'Onboarded',
      this.onboarderedRowData.length,
    );
    setTabLabel(
      VendorListEnum.updateRequests,
      'Update Request',
      this.updateRequestRowData.length,
    );
  }

  onTabChange(tab: any) {
    if (!tab) return;
    this.selectedTab = tab;
    this.paginationParams.pageIndex = 0;
    this.updatePaginationParams();
  }

  updatePaginationParams() {
    if (this.selectedTab?.key?.includes(VendorListEnum.onBoardered)) {
      this.paginationParams.totalItems = this.onboarderedRowData?.length ?? 0;
    } else {
      this.paginationParams.totalItems = this.updateRequestRowData?.length ?? 0;
    }
  }

  get currentColumnDefs() {
    const validKeys = Object.keys(this.columnDefs) as Array<
      keyof typeof this.columnDefs
    >;
    const key = this.selectedTab?.key as string;
    if (validKeys.includes(key as any)) {
      return this.columnDefs[key as keyof typeof this.columnDefs] || [];
    }
    return [];
  }

  get currentRowData() {
    if (this.selectedTab?.key?.includes(VendorListEnum.onBoardered)) {
      return this.onboarderedRowData || [];
    } else {
      return this.updateRequestRowData || [];
    }
  }

  onPageChange(event: any) {
    if (
      event &&
      event.pageIndex !== undefined &&
      event.pageSize !== undefined
    ) {
      this.paginationParams.pageIndex = event.pageIndex;
      this.paginationParams.pageSize = event.pageSize;
    }
  }

  navigateToVendorDashboard(): void {
    this.router.navigate(['/ops-vendor-management']);
  }

  onActionClick(rowIndex: number, event: MouseEvent) {
    if (!event) return;
    event.stopPropagation();
    if (this.showDropdown && this.dropdownRowIndex === rowIndex) {
      this.showDropdown = false;
      this.dropdownRowIndex = null;
      return;
    }
    this.showDropdown = true;
    this.dropdownRowIndex = rowIndex;
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    if (!rect) return;
    this.dropdownPosition = {
      position: 'fixed',
      top: `${rect.bottom + 4}px`,
      left: `${rect.left}px`,
      zIndex: 1000,
    };
  }

  onDropdownMenuAction(row: any, action: string) {
    this.showDropdown = false;
    this.dropdownRowIndex = null;
    if (!action) return;
    switch (action) {
      case 'updateAndResend':
        // Logic for update and resend
        break;
      case 'submitForAccountCreation':
        // Logic for submit for account creation
        break;
      case 'cancelInvitation':
        // Logic for cancel invitation
        break;
      case 'disableVendor':
        // Logic for disable vendor
        break;
      default:
        break;
    }
  }

  // Add this method for template usage
  truncateText(text: string, maxLength: number): string {
    return truncateText(text, maxLength);
  }
}
